import { createSelectFieldsDto, type SelectFieldsInterface } from '@zaoblako/shared/common/dtos/select-fields.dto';
import { UserGroupFindDto, type UserGroupFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';

/** Registry column keys for user groups BASIS (`select` filter / column picker). */
export type UserGroupRegistryColumnKey = 'name' | 'users';

export const USER_GROUP_REGISTRY_COLUMN_KEYS: UserGroupRegistryColumnKey[] = [
  'name',
  'users',
];

/** Default visible registry columns for user groups BASIS (`select` filter). */
export const USER_GROUP_REGISTRY_DEFAULT_SELECT: UserGroupRegistryColumnKey[] = [...USER_GROUP_REGISTRY_COLUMN_KEYS];

/** Registry `select` for dropdowns and widgets. */
export const USER_GROUP_WIDGET_REGISTRY_SELECT = [
  'id',
  'name',
  'usersCount',
] as const satisfies readonly (keyof UserGroupFindInterface)[];

/** User groups BASIS registry column selection - DTO signature */
export type UserGroupRegistrySelectInterface = SelectFieldsInterface<UserGroupFindInterface>;

/** User groups BASIS registry column selection - DTO schema */
export const UserGroupRegistrySelectDto = createSelectFieldsDto(
  SecurityDtoKeysEnum.USER_GROUP_REGISTRY_SELECT_DTO,
  UserGroupFindDto,
  {
    default: [...USER_GROUP_REGISTRY_DEFAULT_SELECT] as (keyof UserGroupFindInterface)[],
  },
);
